import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import ServiceGroupsList from 'components/ServiceGroupsList';
import Pagination from 'components/Pagination';
import Search from 'components/Search';

import { withData } from 'lib';
import { SettingsServiceGroupListPageQuery } from '__generated__/SettingsServiceGroupListPageQuery.graphql';

const query = graphql`
  query SettingsServiceGroupListPageQuery($first: Int!) {
    ...ServiceGroupsList_data @arguments(first: $first)
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsServiceGroupListPageQuery>;
};

const SettingsServiceGroupListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<SettingsServiceGroupListPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { link: '/settings', name: 'Nustatymai' },
        { name: 'Papildomų paslaugų paketai' },
      ]}>
      <Pagination>
        <Search>
          <ServiceGroupsList data={data} />
        </Search>
      </Pagination>
    </Page>
  );
};

export default withData<SettingsServiceGroupListPageQuery>({
  query,
})(SettingsServiceGroupListPage);
